import * as React from "react";
import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { Delete } from "@mui/icons-material";

export type DeleteIconButtonProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    tooltip?: React.ReactNode;
    square?: boolean;
} & Omit<IconButtonProps, "onClick">;


export const DeleteIconButton = React.forwardRef<HTMLButtonElement, DeleteIconButtonProps>(
    ({ onClick, tooltip = "delete", square = false, size = "small", sx, ...rest }, ref) => {
        return (
            <Tooltip title={tooltip}>
                <span>
                    <IconButton
                        ref={ref}
                        onClick={onClick}
                        size={size}

                        sx={{

                            color: "action.active",
                            "&:hover": { color: "error.main" },
                            ...(square && { borderRadius: 1, px: 1 }),
                            ...sx,
                        }}
                        {...rest}
                    >
                        <Delete fontSize={size === "small" ? "small" : "medium"} />
                    </IconButton>
                </span>
            </Tooltip>
        );
    }
);

